module.exports = __webpack_public_path__ + "static/media/IEEE_logo1.fc74a0b6.jpg";